import React from "react";
import { NavLink } from "react-router-dom";

function Portfolio() {
  return (
    <div>
      <div className="inner-hero">
        <div className="container">
          <div className="page-tittle">
            <h2>Portfolio</h2>
            <ul className="breadcam">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <i className="fas fa-angle-right" />
              </li>
              <li>Portfolio</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="portfolio2">
        <div className="container">
          <div
            className="btn-group btn-group-toggle shuffleFilter"
            data-toggle="buttons"
          >
            {/* <label className="btn active">
              <input
                type="radio"
                name="shuffle-filter"
                defaultValue="all"
                defaultChecked="checked"
              />
              All
            </label>
            <label className="btn">
              <input
                type="radio"
                name="shuffle-filter"
                defaultValue="portfolio"
              />
              Portfolio
            </label>
            <label className="btn">
              <input
                type="radio"
                name="shuffle-filter"
                defaultValue="ecommerce"
              />
              Ecommerce
            </label>
            <label className="btn">
              <input
                type="radio"
                name="shuffle-filter"
                defaultValue="business"
              />
              Business
            </label> */}
          </div>
          <div className="row my-shuffle-container">
            <div
              className="col-md-4 single-portfolio"
              data-groups='["ecommerce","Wordpress"]'
            >
              <a className="expand-img" href="https://mehomagroceries.com">
                <img
                  src="assets/img/portfolio/mehomagroceries.png"
                  alt
                  title="portfolio"
                />
                <div className="port-text">
                  <h3>Ecommerce</h3>
                  <p>WordPress Design</p>
                </div>
              </a>
            </div>
            <div
              className="col-md-4 single-portfolio"
              data-groups='["business","Mern"]'
            >
              <a
                className="expand-img"
                href="https://next-tourist-destination.vercel.app/"
              >
                <img
                  src="assets/img/portfolio/Minimalist Neutral Multi Device Computer Mockup Website Launch Instagram Po_20241002_084804_0000.png"
                  alt
                  title="portfolio"
                />
                <div className="port-text">
                  <h3>Business</h3>
                  <p>MERN Stack </p>
                </div>
              </a>
            </div>
            <div
              className="col-md-4 single-portfolio"
              data-groups='["portfolio","HTML CSS"]'
            >
              <a
                className="expand-img"
                href="https://photography-5k4e.vercel.app/case-details.html"
              >
                <img
                  src="assets/img/portfolio/port.png"
                  alt
                  title="portfolio"
                />
                <div className="port-text">
                  <h3>Portfolio</h3>
                  <p>HTML & CSS</p>
                </div>
              </a>
            </div>
            <div className="col-1 Ssizer-element" />
          </div>
        </div>
      </div>
      <div className="hire hire3 hire3-v2">
        <div className="container">
          <div className="hire-details">
            <div className="row">
              <div className="col-md-5">
                <div className="hire-text">
                  <h2>Let’s discuss your projects now</h2>
                  <p>
                    I am available for freelance work. Connect with me via
                    whatsapp:{" "}
                    <strong className="strong">+234 90 5678 9309</strong> or
                    email:{" "}
                    <strong className="strong">macprince.dev@gmail.com</strong>
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <div className="hire-info">
                  <form>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Name"
                          onfocus="this.placeholder = ''"
                          onblur="this.placeholder ='Name'"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Email"
                          onfocus="this.placeholder = ''"
                          onblur="this.placeholder ='Email'"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          name="subjet"
                          id="subjet"
                          placeholder="Subjet"
                          onfocus="this.placeholder = ''"
                          onblur="this.placeholder ='Subjet'"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          name="budget"
                          id="budget"
                          placeholder="Budget"
                          onfocus="this.placeholder = ''"
                          onblur="this.placeholder ='Budget'"
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <textarea
                          rows={4}
                          className="form-control"
                          name="msg"
                          id="msg"
                          placeholder="Message"
                          onfocus="this.placeholder =''"
                          onblur="this.placeholder ='Message'"
                          defaultValue={""}
                        />
                      </div>
                      <button type="submit" id="submit" className="btn-1">
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
